import { Loading } from "@/components/ui/loading";
import { RouteRoute } from "@/modules/routes/routes/route.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/routes/$routeId/")({
	component: RouteRoute,
	pendingComponent: Loading,
});
